import { Run, RunState, RunType } from "types/generated";

export const shouldContinuePolling = (run: {
  finished: Run["finished"];
  promoteBlocker?: Run["promoteBlocker"];
}) => {
  const hasPromoteBlocker = !!run?.promoteBlocker;

  return !run.finished || (run.finished && !hasPromoteBlocker);
};

export const shouldStopPolling = (run: Run) => !shouldContinuePolling(run);

export const shouldContinuePollingNextRun = (run: Run) => {
  const hasNext = !!run?.next?.id;
  const hasPollTypes = run?.type === RunType.Tracked || run?.type === RunType.Task;

  return hasPollTypes && !hasNext;
};

export const shouldStopPollingNextRun = (run: Run) => !shouldContinuePollingNextRun(run);

export const isModuleRunType = (type: RunType) =>
  type === RunType.Testing || type === RunType.Parse;

// Mirrors `terminalStates` in the backend: https://github.com/spacelift-io/backend/blob/main/database/run_state.go
export const isTerminalRunState = (state: RunState) => {
  switch (state) {
    case RunState.Canceled:
    case RunState.Failed:
    case RunState.Finished:
    case RunState.Discarded:
    case RunState.Stopped:
    case RunState.Skipped:
      return true;
    case RunState.Queued:
    case RunState.Ready:
    case RunState.Pending:
    case RunState.PendingReview:
    case RunState.Unconfirmed:
    case RunState.Confirmed:
    case RunState.ReplanRequested:
    case RunState.Preparing:
    case RunState.PreparingApply:
    case RunState.PreparingReplan:
    case RunState.Initializing:
    case RunState.Planning:
    case RunState.Applying:
    case RunState.Performing:
    case RunState.Destroying:
    case RunState.Unknown:
      return false;
  }
};
